<template>
  <div class="main-wrapper">
    <layout-header />

    <div class="content container">
      <div class="px-3">
        <div class="row">
          <div class="col-lg-3 d-lg-block d-none theiaStickySidebar mb-3">
            <div class="stickyside">
              <div class="rounded-xl d-none d-lg-block shadow-sm p-2"><vendor-sidebar></vendor-sidebar></div>
            </div>
          </div>

          <div class="col-lg-9 col-md-12 mb-5">
            <div class="border-bottom mb-3">
              <h2>Matchs</h2>
            </div>

            <div class="d-flex justify-content-center align-items-center">
              <a v-for="tab in tabs" @click="getMatches(tab.id)"
                :class="{ 'bg-warning-light': activeTab === tab.id, 'ml-1': tab.id !== tabs[0].id }"
                href="javascript:void(0)" class="position-relative badge badge-pill text-dark bg-light text-xs py-3 px-3">
                <span class="px-1">{{ tab.label }}</span>
                <span v-if="tab.count > 0"
                  class="badge badge-dark text-white position-absolute mr-2 mt-2 p-1 rounded-xl"
                  style="min-width: 20px; top:0; right:0; transform: translate(50%, -50%);">
                  {{ tab.count }}
                </span>
              </a>
            </div>

            <div class="tab-content py-3 mb-5">
              <div class="tab-pane fade show active pt-3">
                <div v-if="matches.length === 0" class="text-center">
                  <span class="text-sm d-block mb-4 mt-2">Aucun match.</span>
                </div>
                <div v-else>
                  <div class="table-responsive text-xs p-lg-2 p-0 mt-2">
                    <table class="table table-hover table-center mb-0">
                      <thead class="bg-light">
                        <tr>
                          <th>Match</th>
                          <th>Terrain / Le</th>
                          <th>Statut</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="match in paginatedData" :key="match.id" class="position-relative">
                          <td style="min-width: 160px;">
                            <div>
                              <div class="d-flex justify-content-between align-items-center mb-1">
                                <div class="d-flex justify-content-start align-items-center">
                                  <img :src="match.team_a?.logo || defaultLogoPath" class="mr-1 p-1 bg-white rounded-lg" style="width: 42px;height: 42px;"/>
                                  <span>{{ match.team_a?.name || 'N/A' }}</span>
                                </div>
                                <b class="text-center" style="width: 20px">{{ match.status !== 'completed' ? '-' : match.score_a }}</b>
                              </div>
                              <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex justify-content-start align-items-center">
                                  <img :src="match.team_b?.logo || defaultLogoPath" class="mr-1 p-1 bg-white rounded-lg" style="width: 42px;height: 42px;"/>
                                  <span>{{ match.team_b?.name || 'N/A' }}</span>
                                </div>
                                <b class="text-center" style="width: 20px">{{ match.status !== 'completed' ? '-' : match.score_b }}</b>
                              </div>
                            </div>
                          </td>
                          <td style="min-width: 100px" class="text-center">
                            <div v-if="match.booking">
                              <div class="d-flex justify-content-start align-items-center mb-2">
                                <img :src="match.booking?.slot.facility.establishment.logo_url || defaultLogoPath" class="mr-2 p-2 bg-white rounded-lg" style="width: 46px;height: 46px;"/>
                                <div class="d-flex flex-column justify-content-center">
                                  <span>Terrain {{ match.booking?.slot.facility.name }}</span>
                                  <span class="text-muted">{{ match.booking?.slot.facility.establishment.business_name }}</span>
                                </div>
                              </div>
                              <div>
                                {{ formatDateTime(match.booking?.start_time).date }}
                                <span class="d-block text-muted text-sm">
                                  {{ formatDateTime(match.booking?.start_time).time }} - {{ formatDateTime(match.booking?.end_time).time }}
                                </span>
                              </div>
                            </div>
                            <div v-else>N.A.</div>
                          </td>
                          <td>
                            <span :class="statuses[match.status]?.class || 'bg-light'" class="badge badge-pill text-xs py-1 px-2 my-1 mr-1">
                              {{ statuses[match.status]?.label || match.status }}
                            </span>
                          </td>
                          <td>
                            <a v-if="['scheduled','completed'].includes(match.status)" :href="'/my/admin/matches/' + match.id" class="btn btn-sm btn-primary">Détails</a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <nav class="mt-3">
                    <ul class="pagination justify-content-center">
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <button class="page-link text-dark" @click="goToPage(currentPage - 1)">
                          <span class="material-symbols-outlined text-sm">arrow_back</span>
                        </button>
                      </li>
                      <li class="page-item" v-for="page in totalPages" :key="page" :class="{ active: currentPage === page }">
                        <button class="page-link" @click="goToPage(page)" :class="{ 'text-white': currentPage === page, 'text-muted': currentPage !== page }">
                          {{ page }}
                        </button>
                      </li>
                      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                        <button class="page-link text-dark" @click="goToPage(currentPage + 1)">
                          <span class="material-symbols-outlined text-sm">arrow_forward</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <layout-footer />
  </div>
</template>

<script>
import moment from 'moment'
import { api } from '@/store'
import defaultLogoPath from '@/assets/img/default-team-logo.png'
import VendorSidebar from '@/components/Vendors/Partials/Sidebar'

export default {
  components: {
    'vendor-sidebar': VendorSidebar,
  },
  computed: {
    totalPages() {
      return Math.max(1, Math.ceil(this.matches.length / this.perPage))
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.perPage
      return this.matches.slice(start, start + this.perPage)
    }
  },
  data() {
    return {
      defaultLogoPath,
      activeTab: 'ongoing',
      tabs: [
        { id: 'ongoing', label: 'En cours', count: 0 },
        { id: 'scheduled', label: 'À venir', count: 0 },
        { id: 'completed', label: 'Terminé', count: 0 },
        { id: 'cancelled', label: 'Annulé', count: 0 },
      ],
      statuses: {
        challenged: { label: 'en cours', class: 'bg-warning-light' },
        scheduled: { label: 'à venir', class: 'bg-primary-light' },
        completed: { label: 'terminé', class: 'bg-success-light' },
        cancelled: { label: 'annulé', class: 'bg-danger text-white' },
      },
      matches: [],
      allMatches: [],
      currentPage: 1,
      perPage: 5,
    }
  },
  mounted() {
    this.getMatches(this.activeTab)
  },
  methods: {
    formatDateTime(datetimeString) {
      if (!datetimeString) return { date: '-', time: '-', datetime: '' }
      const date = moment(datetimeString)
      const formattedDate = date.format('DD MMM YYYY').replace(/\b\p{L}/u, letter => letter.toUpperCase()).replace(/\./g, '')
      const hours = date.format('HH')
      const minutes = date.format('mm')
      return {
        date: formattedDate,
        time: `${hours}:${minutes}`,
        datetime: `${formattedDate} ${hours}:${minutes}`,
      }
    },
    countByTabs() {
      const now = moment().format('YYYY-MM-DDTHH:mm:ss.000000')
      const counters = {
        ongoing: this.allMatches.filter(m => m.status === 'challenged').length,
        scheduled: this.allMatches.filter(m => m.status === 'scheduled' && m.booking?.start_time > now).length,
        completed: this.allMatches.filter(m => m.status === 'completed' || (m.status === 'scheduled' && m.booking?.start_time <= now)).length,
        cancelled: this.allMatches.filter(m => m.status === 'cancelled').length,
      }
      this.tabs.forEach(t => {
        t.count = counters[t.id] || 0
      })
    },
    getMatches(status = null) {
      this.activeTab = status || this.activeTab
      this.currentPage = 1
      api.get('/private/matches').then(response => {
        this.allMatches = response.data || []
        this.countByTabs()
        const now = moment().format('YYYY-MM-DDTHH:mm:ss.000000')
        if (this.activeTab === 'ongoing') {
          this.matches = this.allMatches.filter(m => m.status === 'challenged')
        } else if (this.activeTab === 'scheduled') {
          this.matches = this.allMatches.filter(m => m.status === 'scheduled' && m.booking?.start_time > now)
        } else if (this.activeTab === 'completed') {
          this.matches = this.allMatches.filter(m => m.status === 'completed' || (m.status === 'scheduled' && m.booking?.start_time <= now))
          this.matches = this.matches.map(m => ({ ...m, status: 'completed' }))
        } else if (this.activeTab === 'cancelled') {
          this.matches = this.allMatches.filter(m => m.status === 'cancelled')
        }
      })
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) this.currentPage = page
    },
  },
}
</script>
